import React from "react";
import { api, getToken, setToken, clearToken, authHeaders } from "@/lib/api";

const Ctx = React.createContext(null);
export const useAdminAuth = () => React.useContext(Ctx);

export const AdminAuthProvider = ({ children }) => {
  const [user, setUser] = React.useState(null);

  React.useEffect(() => {
    if (!getToken()) {
      setUser(false);
      return;
    }
    api
      .get("/auth/me", { headers: authHeaders() })
      .then(({ data }) => setUser(data))
      .catch(() => {
        clearToken();
        setUser(false);
      });
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    setToken(data.token);
    setUser(data.user);
  };

  const logout = () => {
    clearToken();
    setUser(false);
  };

  return <Ctx.Provider value={{ user, login, logout }}>{children}</Ctx.Provider>;
};
